module.exports = __webpack_public_path__ + "img/yfc-thumb1.5c8f24ce.png";